import type { WorkbookCell } from "../../../shared/production/plan-workbook";

export function workbookCellInput(cell: WorkbookCell | null): string {
  if (!cell || cell.value === null) return "";
  return cell.kind === "number" ? String(cell.value).replace(".", ",") : String(cell.value);
}

export function workbookInputValue(cell: WorkbookCell, input: string): string | number | boolean | null {
  if (input.trim() === "") return null;
  if (cell.kind === "number") {
    const text = input.trim();
    const grouped = /^[+-]?[1-9]\d{0,2}(?:\.\d{3})+(?:,\d+)?$/.test(text);
    const normalized = grouped ? text.replaceAll(".", "").replace(",", ".") : text.replace(",", ".");
    if (!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i.test(normalized)) throw new Error("Geçerli bir sayı girin. Örnek: 1.000,5");
    const value = Number(normalized);
    if (!Number.isFinite(value)) throw new Error("Geçerli bir sayı girin.");
    return value;
  }
  if (cell.kind === "boolean") {
    if (/^(true|doğru|1)$/i.test(input)) return true;
    if (/^(false|yanlış|0)$/i.test(input)) return false;
    throw new Error("DOĞRU veya YANLIŞ girin.");
  }
  return input;
}

export function adjacentWorkbookCell(
  rows: Array<{ cells: WorkbookCell[] }>, address: string, key: string,
): WorkbookCell | null {
  const rowIndex = rows.findIndex(row => row.cells.some(cell => cell.address === address));
  const cells = rows[rowIndex]?.cells;
  const cellIndex = cells?.findIndex(cell => cell.address === address) ?? -1;
  const cell = cells?.[cellIndex];
  if (!cell || !cells) return null;
  if (key === "ArrowLeft") return cells[cellIndex - 1] ?? null;
  if (key === "ArrowRight") return cells[cellIndex + 1] ?? null;
  const row = rows[rowIndex + (key === "ArrowUp" ? -1 : key === "ArrowDown" ? 1 : 0)];
  if (!row || (key !== "ArrowUp" && key !== "ArrowDown")) return null;
  let candidate: WorkbookCell | null = null;
  for (const next of row.cells) if (next.column <= cell.column) candidate = next;
  return candidate;
}
